import React from 'react';
import { MenuItem, Select, FormControl, InputLabel, Box } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import { GridFilterInputValueProps } from '@mui/x-data-grid';

export interface SelectFilterOption {
  value: string;
  label: string;
}

interface SelectFilterProps extends GridFilterInputValueProps {
  options: SelectFilterOption[];
}

export default function SelectFilter(props: SelectFilterProps) {
  const { item, applyValue, options } = props;

  const handleChange = (event: SelectChangeEvent<string>) => {
    applyValue({ ...item, value: event.target.value });
  };

  return (
    <FormControl
      fullWidth
      size="small"
      sx={{
        marginTop: '7px',
      }}
    >
      <InputLabel shrink>Value</InputLabel>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          height: '100%',
          marginTop: '5px',
        }}
      >
        <Select
          value={item.value ?? ''}
          onChange={handleChange}
          displayEmpty
          size="small"
          sx={{
            width: '100%',
            border: 'none',
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: 'none',
              boxShadow: 'none',
            },
          }}
        >
          {options.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </FormControl>
  );
}
